import React from 'react';

const Loader: React.FC = () => (
  <div className='w-10 h-10 bg-[#333] my-24 mx-auto loader' />
);

export default Loader;
